import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { OrganizationSharedModel } from './organization-shared-model';

@JsonObject('KovanHrPersonnelSharedModel')
export class PersonnelSharedModel{

    @EmptyControl()
	@JsonProperty('peopleId', Number, true)
	peopleId: number = null;

    @EmptyControl()
	@JsonProperty('peopleUuid', String, true)
	peopleUuid: string = null;

    @EmptyControl()
	@JsonProperty('beginDate', HvlDateConverter, true)
	beginDate: Date = null;

    @EmptyControl()
	@JsonProperty('endDate', HvlDateConverter, true)
	endDate: Date = null;

    @EmptyControl()
	@JsonProperty('peopleNum', Number, true)
	peopleNum: number = null;

    @EmptyControl()
    @JsonProperty('regNum', String, true)
    regNum: string = null;

    @EmptyControl()
	@JsonProperty('peopleStatus', String, true)
	peopleStatus: string = null;

    @EmptyControl()
	@JsonProperty('employeeTypeUuid', String, true)
	employeeTypeUuid: string = null;

    @EmptyControl()
	@JsonProperty('employeeSubtypeUuid', String, true)
	employeeSubtypeUuid: string = null;

    @EmptyControl()
	@JsonProperty('workAreaUuid', String, true)
	workAreaUuid: string = null;

    @EmptyControl()
	@JsonProperty('workSubareaUuid', String, true)
	workSubareaUuid: string = null;

    @EmptyControl()
	@JsonProperty('orgUnitId', Number, true)
	orgUnitId: number = null;

    @EmptyControl()
    @JsonProperty('orgUnit', OrganizationSharedModel, true)
    orgUnit: OrganizationSharedModel = null;

    @EmptyControl()
	@JsonProperty('positionDefinitionId', Number, true)
	positionDefinitionId: number = null;

    @EmptyControl()
	@JsonProperty('name', String, true)
	name: string = null;

    @EmptyControl()
	@JsonProperty('surname', String, true)
	surname: string = null;

    @EmptyControl()
	@JsonProperty('identificationNumber', String, true)
	identificationNumber: string = null;

    @EmptyControl()
	@JsonProperty('payrollSwitchUuid', String, true)
	payrollSwitchUuid: string = null;

    @EmptyControl()
	@JsonProperty('fullName', String, true)
	fullName: string = null;
}
